import { Box, Typography, Grid2 as Grid, Alert, AlertTitle } from "@mui/material";
import uniq from "lodash-es/uniq";
import React from "react";
import { Tip } from "../../components/Tip";
import { Footer } from "../../components/Footer";
import { useContactLinks } from "../../hooks/useContactLinks";
import ActionWithAi from "../../components/ActionWithAi";
import AssignButton from "../../components/AssignButton";
import { TaskModel } from "../../models/TaskModels";
import { useTasksContact } from "../../hooks/useTasksContact";
import { useTasksEmail } from "../../hooks/useTasksEmail";
interface Props {
  email: string;
}

export function ContactNotFound({ email }: Props) {
  const { tasks } = useTasksContact();
  const { tasks: tasksEmail } = useTasksEmail();
  const emailDomain = email.split("@")[1];

  const { links, isLoading } = useContactLinks();
  const hasNoLink = !isLoading && !links?.addCustomerLink && !links?.addVendorLink;
  const isSingle = uniq(Object.values(links ?? {})).filter(Boolean).length === 1;

  const extraActions = React.useMemo(() => {
    const actions: TaskModel[] = [];

    return [...actions, ...(tasks ?? []), ...(tasksEmail ?? [])];
  }, [isSingle, links?.addCustomerLink, links?.addVendorLink, tasks, tasksEmail]);

  return (
    <>
      <Tip title="No contact found" pb={20}>
        <Typography fontWeight={600}>No contact has this domain:</Typography>
        <Box
          width="100%"
          textAlign="center"
          sx={{
            borderRadius: 1,
            backgroundColor: "error.main",
            color: "error.contrastText",
            padding: 1,
            textDecoration: "underline",
          }}
        >
          {emailDomain}
        </Box>
      </Tip>
      <Footer>
        {!hasNoLink && (
          <Alert severity="info">
            <AlertTitle>Why this message?</AlertTitle>
            <Typography component="span">
              Attelas helps you to spot fraudulent emails. If you know the sender, add them to your finance system.
            </Typography>
          </Alert>
        )}
        <Grid container justifyContent="space-between" width="100%">
          <ActionWithAi actions={extraActions} relatedIds={[]} />
          <AssignButton />
        </Grid>
      </Footer>
    </>
  );
}
